import {useMemo} from "react";

import {Country} from "@pg-rp/common-types";
import {getMainCityBySelectedRegions} from "@pg-rp/interactive-regions-map";

import {useGetRegionsQuery} from "../api/get_regions_api";
import {GetRegionDetailsDto} from "../types/GetRegionDetailsDto";

interface IProps {
    regionIds?: number[];
}

export const useRegionDetails = ({regionIds}: IProps) => {
    const regionIdsMemorized = useMemo(() => {
        return regionIds || [];
    }, [regionIds?.join(",")]);

    const {data} = useGetRegionsQuery({regionIds: regionIdsMemorized}, {skip: !regionIdsMemorized.length});
    const selectedRegionsDetails = useMemo(() => {
        return data?.results || [];
    }, [data]);

    const mainCityId = useMemo(() => {
        const mappedRegionsForValidation = mapRegionDetailsToSelectedRegionParam(selectedRegionsDetails);
        if (mappedRegionsForValidation.length === 0) {
            return null;
        }
        return getMainCityBySelectedRegions(mappedRegionsForValidation);
    }, [selectedRegionsDetails]);

    const {data: mainCityResponse} = useGetRegionsQuery({regionIds: mainCityId ? [mainCityId] : []}, {skip: !mainCityId});
    const mainCityDetails = useMemo(() => {
        return mainCityResponse?.results?.[0] || null;
    }, [mainCityResponse]);

    return {
        selectedRegionsDetails,
        regionIdsMemorized,
        hasAnyRegionDetails: selectedRegionsDetails.length > 0,
        mainCityId,
        mainCityDetails,
        doesRegionsBelongToSameCity: mainCityId !== null
    };
};

const mapRegionDetailsToSelectedRegionParam = (regions: GetRegionDetailsDto[]) => {
    return regions.map((region) => ({
        id: region.id,
        type: region.type,
        country: region.country || Country.POLAND, // Default to Poland if country not specified
        parent: region.parent?.id
    }));
};
import {useMemo} from "react";

import {Country} from "@pg-rp/common-types";
import {getMainCityBySelectedRegions} from "@pg-rp/interactive-regions-map";

import {useGetRegionsQuery} from "../api/get_regions_api";
import {GetRegionDetailsDto} from "../types/GetRegionDetailsDto";

interface IProps {
    regionIds?: number[];
}

export const useRegionDetails = ({regionIds}: IProps) => {
    const regionIdsMemorized = useMemo(() => {
        return regionIds || [];
    }, [regionIds?.join(",")]);

    const {data} = useGetRegionsQuery({regionIds: regionIdsMemorized}, {skip: !regionIdsMemorized.length});
    const selectedRegionsDetails = useMemo(() => {
        return data?.results || [];
    }, [data]);

    const mainCityId = useMemo(() => {
        const mappedRegionsForValidation = mapRegionDetailsToSelectedRegionParam(selectedRegionsDetails);
        if (mappedRegionsForValidation.length === 0) {
            return null;
        }
        return getMainCityBySelectedRegions(mappedRegionsForValidation);
    }, [selectedRegionsDetails]);

    const {data: mainCityResponse} = useGetRegionsQuery({regionIds: mainCityId ? [mainCityId] : []}, {skip: !mainCityId});
    const mainCityDetails = useMemo(() => {
        return mainCityResponse?.results?.[0] || null;
    }, [mainCityResponse]);

    return {
        selectedRegionsDetails,
        regionIdsMemorized,
        hasAnyRegionDetails: selectedRegionsDetails.length > 0,
        mainCityId,
        mainCityDetails,
        doesRegionsBelongToSameCity: mainCityId !== null
    };
};

const mapRegionDetailsToSelectedRegionParam = (regions: GetRegionDetailsDto[]) => {
    return regions.map((region) => ({
        id: region.id,
        type: region.type,
        country: region.country || Country.POLAND, // Default to Poland if country not specified
        parent: region.parent?.id
    }));
};
